module.exports = "<div [ngStyle]=\"styles\" class=\"wrapper\" data-cy=\"card.component\">\n  <ng-content select=\"[card-body]\"></ng-content>\n</div>\n"